export const InputValidationRegexps = {
    INPUT_VALIDATION_REGEX_ROMANIAN_PHONE: '^(07[0-8]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\\s|\\.|\\-)?([0-9]{3}(\\s|\\.|\\-|)){2}$'
};
